import axios from "axios";
import { notConnectedMessage } from "../../components/constants";
import { BASE_API } from "../../utils/constants";
import {
    Api_Response,
    Base_Filter,
    GET,
    IBase_Entity,
    PATCH,
    POST,
} from "../base-services";
import { IBranch_Row } from "../branch/branch-service";

export class Device_Service {
    static url = "/connected-devices";

    static devices: INew_Device[] = [];

    static async create_device(new_device: INew_Device) {
        return POST<any[]>(
            `/device`,
            new_device,
            {},
            {
                "x-org": new_device.organization,
                // authorization: `Bearer ${api_key}`,
            }
        );
    }

    static async get_devices(
        org_code: string,
        api_key: string,
        filter: Get_Devices_Filter
    ) {
        return GET<Get_Connected_Devices_Response>(`/device`, filter, {
            "x-org": org_code,
            authorization: `Bearer ${api_key}`,
        });
    }

    static async get_superadmin_devices(
        org_code: string,
        filter: Get_Devices_Filter
    ) {
        return GET<Get_Connected_Devices_Response>(
            `/device/superadmin`,
            filter,
            {
                "x-org": org_code,
            }
        );
    }

    static async edit_device(
        serial: string,
        changes: any,
        org_code: string,
        api_key: string
    ) {
        const response = await PATCH<any[]>(
            "/device",
            changes,
            {
                serial: serial,
            },
            { "x-org": org_code, authorization: `Bearer ${api_key}` }
        );

        return response;
    }

    static async delete_device(serial: string, orgCode: string) {
        try {
            const response = await axios.delete(`${BASE_API}` + "/device", {
                params: { serial: serial, orgCode: orgCode },
                withCredentials: true,
            });

            return [response.data, null];
        } catch (err: any) {
            console.log(err, "Device service");
            return [null, err?.response?.data?.message || notConnectedMessage];
        }
    }

    static async sync_device(serial_no: string, org: string) {
        const response = await POST<Sync_Device_Response>(
            `/user/sync/${serial_no}`,
            {},
            {},
            { "x-org": org }
        );

        return response;
    }

    static async sync_single_portal_user(
        data: any,
        org: string,
        api_key: string
    ) {
        const response = await POST<Sync_Device_Response>(
            `/user/sync-portal-users`,
            data,
            {},
            { "x-org": org, authorization: `Bearer ${api_key}` }
        );

        return response;
    }
}

export enum Device_Status {
    Offline = "offline",
}

export interface INew_Device {
    serial: string;
    // status: Device_Status;
    branch: string;
    name: string;
    firmwareVersion: string;
    faceVersion: string;
    fpVersion: string;
    platform: string;
    organization: string;
}

export interface IDevice_Row
    extends IBase_Entity,
        Omit<INew_Device, "branch" | "organization"> {
    status: Device_Status;
}

export interface IDevice_Row_With_Branch extends IDevice_Row {
    branch: IBranch_Row;
}

type Get_Connected_Devices_Response = Api_Response<{
    success: true;
    message: string;
    rows: IDevice_Row_With_Branch[];
    count: number;
}>;

type Sync_Device_Response = Api_Response<{ message: string }>;

export type Get_Devices_Filter = Base_Filter & {
    serial?: string;
    branchId?: number;
    name?: string;
    search?: string;
    apply?: number;
    apiKey?: string;
};
